import { createSlice } from '@reduxjs/toolkit'

export const selectedSubjectsStore = createSlice({
  name: 'selectedSubjects',
  initialState: {
    value: [],
  },
  reducers: {
    updateSelectedSubject: (state, action) => {
      state.value = action.payload
    },
    defaultSelectedSubjects: (state, action) => {
      state.value = action.payload
    }
  },
})

// Action creators are generated for each case reducer function
export const { updateSelectedSubject, defaultSelectedSubjects } = selectedSubjectsStore.actions

export default selectedSubjectsStore.reducer